import { render, staticRenderFns } from "./policyStatusTxt.vue?vue&type=template&id=6271e4ca&"
import script from "./policyStatusTxt.vue?vue&type=script&lang=js&"
export * from "./policyStatusTxt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports